import { render, staticRenderFns } from "./BoCustomerAddress.vue?vue&type=template&id=4c124836"
import script from "./BoCustomerAddress.vue?vue&type=script&lang=js"
export * from "./BoCustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports